import { Divider, Flex, Tooltip, Typography } from 'antd'
import { Heart } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { DOCS_ORIGIN, PRIVACY_URL } from 'src/constants'

import { useStyles } from './styles'

const { Text } = Typography

const FOOTER_LINKS = [
  { key: 'docs', href: DOCS_ORIGIN },
  { key: 'privacy', href: PRIVACY_URL },
  { key: 'support', href: 'mailto:support@skalx.ai' }
] as const

export const AppFooter = () => {
  const { t } = useTranslation()
  const { styles } = useStyles()
  const year = new Date().getFullYear()

  return (
    <footer className={styles.footer} aria-label={t('shell.footer.ariaLabel')}>
      <Flex align="center" gap={10} wrap className={styles.footerInner}>
        <Flex align="center" gap={8} className={styles.footerMeta}>
          <Text className={styles.footerCopy}>
            © {year} {t('shell.footer.brand')}
          </Text>
          <span className={styles.footerSep} aria-hidden>
            ·
          </span>
          <Tooltip title={t('shell.footer.versionTooltip')}>
            <Text className={styles.footerVersion}>v{__APP_VERSION__}</Text>
          </Tooltip>
        </Flex>

        <Flex align="center" gap={2} className={styles.footerLinks} wrap>
          {FOOTER_LINKS.map((link, i) => (
            <Flex key={link.key} align="center" gap={2}>
              {i > 0 ? (
                <Divider
                  orientation="vertical"
                  className={styles.footerLinkDivider}
                />
              ) : null}
              <a
                className={styles.footerLink}
                href={link.href}
                target="_blank"
                rel="noreferrer noopener"
              >
                {t(`shell.footer.links.${link.key}`)}
              </a>
            </Flex>
          ))}
        </Flex>

        <Flex align="center" gap={5} className={styles.footerPowered}>
          <Text className={styles.footerCopy}>
            {t('shell.footer.poweredBy')}
          </Text>
          <Heart
            size={11}
            className={styles.footerHeart}
            aria-hidden
            fill="currentColor"
          />
          <Text strong className={styles.footerBrand}>
            {t('shell.footer.brand')}
          </Text>
        </Flex>
      </Flex>
    </footer>
  )
}
